/***
 * Created on 2023/10/27
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {useTranslation} from "react-i18next";

function ResetSuccess(props) {
    const { t } = useTranslation();

    return (
        <section className="common-page-wrapper">
            <div className="common-page-header">{t('@Reset Password@')}</div>
            <div className="common-page-body">
                <p>{t('@Your password has been changed.@')}</p>
                <p>{t('@If you account were locked before, it is now restored.@')}</p>
                <p>{t('@Please sign in your QNAP ID on all of your browsers, QNAP mobile apps, and KoiBot again.@')}</p>
            </div>
            <div className="common-page-footer">
                <div className="q-btn-group btn-align-right">
                    <button className="q-btn q-btn--primary btn-medium btn-rounded-normal" onClick={e=>location.replace('/login')}>{t('@Sign in@')}</button>
                </div>
            </div>
        </section>
    );
}

export default ResetSuccess;